/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import signupImg from "../../assets/images/sighup/signup.png";
import googleicon from "../../assets/images/sighup/social-icon.svg";
import linkedicon from "../../assets/images/sighup/linkedin-icon.svg";
import mailicon from "../../assets/images/sighup/mail-icon.svg";
import hide from "../../assets/images/sighup/hide-icon.svg";
import showeye from "../../assets/images/sighup/show-icon.svg";
import { Form } from "react-bootstrap";
import "./popup.css";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { RegisterSchema } from "../../validationSchema/authSchema.js";
import { signup } from "../../utils/Api.js";
import { toast } from "react-toastify";
import { useGoogleLogin } from "@react-oauth/google";
import { authInstance } from "../../config/axios";
import UserContext from "../../context/UserContext";


const SignupPopup = ({ setSignup, setLogin, setUpdateProfile }) => {
  const { user, setUser, setToken } = useContext(UserContext);
  const [next, setNext] = useState(false);
  const [formType, setFormType] = useState(false);
  const [show, setShow] = useState(false);
  const [isVerify, setIsVerify] = useState(false);
  const ref = useRef(null);
  const handleshow = () => {
    setNext(true);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };



  const handlepasswordshow = (value) => {
    if (value === 'password') {
      setShow(!show);
    } else {
      setIsVerify(!isVerify)
    }
  };

  const handleFormChanger = () => {
    setFormType(!formType)
  }

  const handleGoogleSuccess = async (info) => {
    console.log("info", info);
    try {
      if (info.error) {
        return;
      }

      const profilePayload = {
        accessToken: info.access_token,
        role: formType ? 'developer' : 'client',
      };
      // setLoader(true);
      const res = await authInstance.post(
        "/googleLogin",
        profilePayload
        //   {withCredentials: true,
        //   credentials: "include",
        // }
      );
      const {
        status,
        data: {
          tokens: { access, refresh
          },
          user,
          // newUser,
        },
      } = res;
      if (status === 200) {
        setSignup(false)
        setUser(user);
        setToken(access.token);
        localStorage.setItem("token", access?.token);
        localStorage.setItem("userid", user?.id);
        localStorage.setItem("refreshToken", refresh?.token)
        // setTimeout(() => {
        //   if(newUser){
        //   window.location.href = `/profile?newUser=${newUser}`;
        //   }
        //   else {
        //     window.location.href = "/profile";
        //   }
        //   toast.success("You are logged in successfully", {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //   });
        // }, 1000);
      }
    } catch (err) {
      console.log("errr-->", err);
      // setLoader(false);
      // toast.error(err.response.data.message, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      // });
    }
  };

  const login = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: (error) => console.log("Login Failed:", error),
  });

  console.log('user-------d--d----->', user);
  return (
    <div className='signup-popup-content'>
      <div className='signup-popup-left'>
        {next ? (
          // <Signin handlepasswordshow={handlepasswordshow} />
          <SignupLeftForm
            show={show}
            handlepasswordshow={handlepasswordshow}
            ref={ref}
            signup={signup}
            setSignup={setSignup}
            setLogin={setLogin}
            setUpdateProfile={setUpdateProfile}
            isVerify={isVerify}
            handleFormChanger={handleFormChanger}
            formType={formType}
            setToken={setToken}
            setUser={setUser}
          />
        ) : (
          <SignupLeft handleshow={handleshow} handleFormChanger={handleFormChanger} formType={formType} login={login} />
        )}
      </div>
      <div className='signup-popup-right'>
        <img src={signupImg} alt='signup' />
      </div>
    </div>
  );
};

export default SignupPopup;

const SignupLeft = ({ handleshow, handleFormChanger, formType, login }) => {

  return (
    <div className='signup-left-content'>
      <div className='signup-popup-text'>
        <h4>
          Create a <span>free account</span> to view {formType ? ' developers ' : ' client '} in our database.
        </h4>
        <p>
          Lorem Ipsum has been the industry's standard dummy text ever since the
          1500s, Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s,
        </p>
      </div>
      <div className='signup-popup-buttons'>
        <Button className='signup-btn' onClick={() => login()}>
          <img src={googleicon} alt='google' />
          Sign in with Google
        </Button>
        <Button className='signup-btn'>
          <img src={linkedicon} alt='linkedin' />
          Sign in with Linked In
        </Button>
        <Button className='signup-btn' onClick={handleshow}>
          <img src={mailicon} alt='mail' />
          Sign in with Email
        </Button>

        <div className='signup-popup-account'>
          <p>
            If you are a {formType ? ' developer ' : ' client '} <a onClick={handleFormChanger}>Click here</a> !
          </p>
          <p>
            Already have an account? <Link to='/'>Sign In</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

const SignupLeftForm = ({
  show,
  handlepasswordshow,
  ref,
  signup,
  setSignup,
  setLogin,
  setUpdateProfile,
  isVerify,
  handleFormChanger, formType, setUser, setToken,

}) => {
  return (
    <>
      <div className='signup-popup-text' ref={ref}>
        <h4>
          Create a <span>free account</span> to view developers in our database.
        </h4>
        <p>
          Lorem Ipsum has been the industry's standard dummy text ever since the
          1500s.
        </p>
      </div>
      <SignupInput
        show={show}
        handlepasswordshow={handlepasswordshow}
        signup={signup}
        setSignup={setSignup}
        setLogin={setLogin}
        setUpdateProfile={setUpdateProfile}
        isVerify={isVerify}
        handleFormChanger={handleFormChanger}
        formType={formType}
        setToken={setToken}
        setUser={setUser}
      />
    </>
  );
};

const SignupInput = ({
  show,
  handlepasswordshow,
  signup,
  setSignup,
  setLogin,
  setUpdateProfile,
  isVerify,
  formType,
  setUser,
  setToken,


}) => {
  // const [showPasswordEye, setShowPasswordEye] = useState([]);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      role: "",
    },
    resolver: yupResolver(RegisterSchema),
  });

  const handleSignup = async (values) => {
    const role = formType ? 'developer' : 'client';
    const newValue = { ...values, role: role }
    try {
      const res = await signup(newValue);
      if (res.user) {
        console.log('user data kya hai -------->>>>>', res);
        const { tokens, user } = res
        setUser(user);
        setToken(tokens.access.token);
        localStorage.setItem("token", tokens.access.token);
        localStorage.setItem("userid", user?.id);
        toast.success("You are successfully registered ");
        setSignup(false);
        setUpdateProfile(true);
        const newNameFirst = user?.name ? user?.name?.split(' ') : [];
        const newLastName = newNameFirst[newNameFirst?.length - 1]
        const payload = {
          firstName: user.firstName ? user.firstName : newNameFirst[0],
          lastName: user.lastName ? user.lastName : newLastName,
          email: user.email,
          phone: user?.phoneNumber ? user?.phoneNumber : "",

        }
        if (user.role === 'client') {
          const newPayload = { ...payload, password: values?.password }
          console.log({ newPayload });
          // await createUserForGHL(newPayload)
        } else {
          // await createContactForGHL(payload)
        }

        // setLogin(true)
        // window.location.href='/profile-update';
      }
    } catch (error) {
      console.log("error--->", error);
    }
    // if (res.code !== 401) {
    //   setIsRegister(true);
    //   setTimeout(() => {
    //     setIsRegister(false);
    //     window.location.href = "/";
    //   }, 2000);
    // }
  };
  return (
    <div className='signup-input-content'>
      <Form onSubmit={handleSubmit(handleSignup)}>
        <div className='signup-top'>
          <Form.Group className='dev-input'>
            <label>First Name</label>
            <Form.Control
              type='text'
              placeholder='Enter your first name'
              name='firstName'
              className={errors.firstName ? "error-field" : ""}
              {...register("firstName")}
            />
            {errors?.firstName ? (
              <p className='error-text'>{errors.firstName.message}</p>
            ) : (
              ""
            )}
          </Form.Group>
          <Form.Group className='dev-input'>
            <label>Last Name</label>
            <Form.Control
              type='text'
              placeholder='Enter your last name'
              name='lastName'
              className={errors.lastName ? "error-field" : ""}
              {...register("lastName")}
            />
            {errors?.lastName ? (
              <p className='error-text'>{errors.lastName.message}</p>
            ) : (
              ""
            )}
          </Form.Group>
        </div>
        {/* <Form.Group className='dev-input'>
          <div className='form-role'>
            <label>Role</label>

            <select {...register("role")}>
              <option value='' disabled>
                Select option
              </option>
              <option value='client'>Client</option>
              <option value='developer'>Developer</option>
            </select>
            {errors?.role ? (
              <p className='error-text'>{errors.role.message}</p>
            ) : (
              ""
            )}
          </div>
        </Form.Group> */}
        <Form.Group className='dev-input'>
          <label>Phone</label>
          <Form.Control
            type='number'
            placeholder='Enter your mail name'
            name='phoneNumber'
            {...register("phoneNumber")}
            className={errors.phoneNumber ? "error-field" : ""}
          />
          {errors?.phoneNumber ? (
            <p className='error-text'>{errors.phoneNumber.message}</p>
          ) : (
            ""
          )}
        </Form.Group>
        <Form.Group className='dev-input'>
          <label>Email</label>
          <Form.Control
            type='text'
            placeholder='Enter your mail name'
            name='email'
            className={errors.email ? "error-field" : ""}
            {...register("email")}
          />
          {errors?.email ? (
            <p className='error-text'>{errors.email.message}</p>
          ) : (
            ""
          )}
        </Form.Group>
        <Form.Group className='dev-input password-input'>
          <label>Password</label>
          <Form.Control
            type={show ? "text" : "password"}
            placeholder='*************'
            name='password'
            {...register("password")}
          />
          {errors?.password ? (
            <p className='error-text'>{errors.password.message}</p>
          ) : (
            ""
          )}
          <div className='password' onClick={() => handlepasswordshow('password')}>
            {show ? (
              <img src={showeye} alt='eye' />
            ) : (
              <img src={hide} alt='eye' />
            )}
          </div>
        </Form.Group>
        <Form.Group className='dev-input password-input'>
          <label>Verify Password</label>
          <Form.Control
            type={isVerify ? "text" : "password"}
            placeholder='*************'
            name='verifyPassword'
            className={errors.verifyPassword ? "error-field" : ""}
            {...register("verifyPassword")}
          />
          {errors?.verifyPassword ? (
            <p className='error-text'>{errors.verifyPassword.message}</p>
          ) : (
            ""
          )}
          <div className='password' onClick={() => handlepasswordshow('verifyPassword')}>
            {isVerify ? (
              <img src={showeye} alt='eye' />
            ) : (
              <img src={hide} alt='eye' />
            )}
          </div>
        </Form.Group>
        <Button className='light-bg-btn' type='submit'>
          Sign up
        </Button>
      </Form>
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const Signin = ({ show, handlepasswordshow }) => {
  return (
    <div className='signup-input-content'>
      <div className='signup-popup-text'>
        <h4>
          Sign in to your <span> account</span>
        </h4>
        <p>
          Lorem Ipsum has been the industry's standard dummy text ever since the
          1500s.
        </p>
      </div>
      <Form>
        <div className='signin-content'>
          <Form.Group className='dev-input'>
            <label>Email</label>
            <Form.Control type='text' placeholder='Enter your mail name' />
          </Form.Group>
          <Form.Group className='dev-input password-input'>
            <label>Password</label>
            <Form.Control
              type={show ? "text" : "password"}
              placeholder='*************'
            />
            <div className='password' onClick={handlepasswordshow}>
              {show ? (
                <img src={showeye} alt='eye' />
              ) : (
                <img src={hide} alt='eye' />
              )}
            </div>
          </Form.Group>
          <div className='signin-option'>
            <div className='signin-remember'>
              <input type='checkbox' />
              <p>Remember</p>
            </div>
            <div className='signin-forgot'>
              <span>Forgot your password?</span>
            </div>
          </div>
        </div>
      </Form>
      <Button className='cta-btn'>Sign In</Button>
      <div className=''>
        <p>
          Don’t have an account?<a href='/'>Sign up</a>
        </p>
      </div>
    </div>
  );
};
